<template>
  <q-dialog
    v-model="shown"
  >
    <q-card
      :style="{
        'width': $q.screen.gt.xs ? '500px' : '100%',
        'max-width': '500px'
      }"
    >
      <q-form
        ref="formRef"
      >
        <q-card-section v-if="siteSelectorItem">
          <div class="column">
            <div
              class="row items-center q-gutter-sm q-mx-xs"
              style="margin-bottom: 10px;"
            >
              <div class="col text-h6">
                {{ formTitle }}
              </div>
              <q-btn
                class="col-auto"
                icon="close"
                flat
                round
                dense
                @click="close"
              />
            </div>
            <div
              v-if="siteSelectorsDisplayType === SITE_SELECTOR_DISPLAY_TYPES.BLOCK"
              class="row q-col-gutter-sm items-star q-mb-md"
            >
              <div class="col-6 column q-col-gutter-sm">
                <model-form-image-uploader
                  :model="sectionClone"
                  :field="`config.siteSelectorItems[${index}].image`"
                  value-type="String"
                  class="col"
                  min-height="150px"
                  :image-url="siteSelectorItemImageUrl(localizedSiteSelectorItem.image)"
                />
              </div>
              <div class="col-6" />
            </div>
            <div class="row q-col-gutter-sm items-start">
              <!-- NOTE: We must pass :model="sectionClone" to all of these for the reasons explained
            in the code comments for `initializeSectionClone()` -->
              <model-form-input
                :model="sectionClone"
                :field="`config.siteSelectorItems[${index}].name`"
                value-type="String"
                class="col-6"
                label="Name"
                :rules="[val => !!val || 'Field is required']"
              />
              <model-form-input
                :model="sectionClone"
                :field="`config.siteSelectorItems[${index}].address`"
                value-type="String"
                class="col-6"
                label="Address"
              />
            </div>
            <div class="row q-col-gutter-md item-start q-mt-md">
              <q-toggle
                v-model="useExternalUrl"
                class="col-6"
                label="External Link"
              />
              <model-form-input
                v-if="useExternalUrl"
                :model="sectionClone"
                :field="`config.siteSelectorItems[${index}].externalUrl`"
                value-type="String"
                class="col-6"
                label="External URL"
                :rules="[val => !!val || 'Field is required']"
              />
              <model-form-select
                v-else
                :model="sectionClone"
                :field="`config.siteSelectorItems[${index}].siteId`"
                value-type="Number"
                class="col-6"
                label="Navigate to Site"
                :options="sitesExcludingLibrary"
                option-label="name"
                option-value="id"
                map-options
                emit-value
                clearable
              />
            </div>
          </div>
        </q-card-section>
        <q-card-actions class="row justify-end q-ma-sm">
          <q-btn
            :label="formSaveLabel"
            color="primary"
            @click="save()"
          />
        </q-card-actions>
      </q-form>
    </q-card>
  </q-dialog>
</template>

<script>
import { SITE_SELECTOR_DISPLAY_TYPES } from 'src/models/page/Section'
import { createSiteSelectorItem, siteSelectorItemImageUrl } from 'src/models/page/SiteSelectorItem'
import SectionConfigArrayElementFormMixin from 'src/modules/admin/components/ModelForm/mixins/SectionConfigArrayElementFormMixin'
import FormValidationMixin from 'src/modules/admin/mixins/FormValidationMixin'

export default {
  name: 'SiteSelectorForm',
  mixins: [SectionConfigArrayElementFormMixin, FormValidationMixin],
  props: {
    siteSelectorsDisplayType: {
      type: String,
      required: false,
      default: SITE_SELECTOR_DISPLAY_TYPES.DROPDOWN
    }
  },
  configuration: ['currentSite', 'sites'],
  emits: ['save'],
  data () {
    return {
      useExternalUrl: false
    }
  },
  computed: {
    // required by mixin
    field () {
      return 'siteSelectorItems'
    },
    // required by mixin
    typeName () {
      return 'Site'
    },
    sitesExcludingLibrary () {
      return _(this.sites.data).filter({ isLibrary: false }).value()
    },
    siteSelectorItem () {
      return this.currentArrayElement
    },
    localizedSiteSelectorItem () {
      if (!this.siteSelectorItem) return null
      const localizedSiteSelectorItem = { ...this.siteSelectorItem }
      localizedSiteSelectorItem.image = this.siteSelectorItem[this.localizeKey('image')] || this.siteSelectorItem.image
      return localizedSiteSelectorItem
    }
  },
  watch: {
    useExternalUrl () {
      if (!this.useExternalUrl && this.siteSelectorItem.externalUrl) {
        this.siteSelectorItem.externalUrl = null
      }
    }
  },
  created () {
    _.extend(this, { siteSelectorItemImageUrl, SITE_SELECTOR_DISPLAY_TYPES })
  },
  unmounted () {
    this.destroySectionClone()
  },
  methods: {
    // required by mixin
    getElementDefaultProps () {
      return createSiteSelectorItem()
    },
    onShow () {
      if (this.isUpdating) {
        this.useExternalUrl = !!this.siteSelectorItem.externalUrl
      }
    },
    save () {
      this.validateForm(() => {
        this.$emit('save', _.clone(this.siteSelectorItem))
        this.close()
      })
    }
  }
}

</script>
